import { ResourceModel } from '@bryntum/schedulerpro';

export class DemandModel extends ResourceModel {
  static get fields() {
    return [
      { name: 'type', type: 'string' },
      { name: 'roleId', type: 'number' },
      { name: 'roleName', type: 'string' },
      { name: 'UserCountByUserType', type: 'object' },
    ];
  }
}
